<template>
  <BaseCard
    :search-result="searchResult"
    class="result-card"
  >
    <template #preview>
      <div class="preview-fallback">
        <Icon
          name="lucide:link"
          size="24"
        />
      </div>
    </template>
    <template #result-content>
      <div
        v-if="searchResult.name"
        class="title"
      >
        {{ searchResult.name }}
      </div>
      <div
        v-if="searchResult.title"
        class="title"
      >
        {{ searchResult.title }}
      </div>
      <div
        v-if="searchResult.snippet"
        class="snippet"
      >
        {{ searchResult.snippet }}
      </div>
      <div
        v-if="searchResult.description"
        class="snippet"
      >
        {{ searchResult.description }}
      </div>
      <div
        v-if="searchResult.publish_date"
        class="dates-and-times"
      >
        <div class="published-at">{{ $t('search.forms.published') }}: {{ formattedDateAndTime }}</div>
        <div class="updated-at"></div>
      </div>
    </template>
  </BaseCard>
</template>

<script setup>
import BaseCard from './BaseCard.vue';
import { computed } from 'vue';
import { monthDayYear } from '../../../helpers/date-utils';
const props = defineProps({
  searchResult: {
    type: Object,
    default: () => ({}),
  },
});
const formattedDateAndTime = computed(() => {
  return monthDayYear(props.searchResult.publish_date) || '';
});
</script>

<style lang="scss" scoped>
.result-card {
  --background-color: #f3f6fc;
  --text-color: #1850c1;
}
</style>
